import { type Meta } from '../types/docs';

export const AGENT_ONBOARDING_AUDIENCES = ['new_user', 'existing_user'] as const;

export type AgentOnboardingAudience = (typeof AGENT_ONBOARDING_AUDIENCES)[number];

export const AGENT_ONBOARDING_SCENE_IDS = ['summarize', 'organize', 'resize', 'animate'] as const;

export type AgentOnboardingSceneId = (typeof AGENT_ONBOARDING_SCENE_IDS)[number];

export const AGENT_ONBOARDING_WALKTHROUGH_STEPS = [
  'welcome',
  'logo_flight',
  ...AGENT_ONBOARDING_SCENE_IDS,
  'outcomes',
] as const;

export type AgentOnboardingWalkthroughStep = (typeof AGENT_ONBOARDING_WALKTHROUGH_STEPS)[number];

/** Matches `WORKSPACE_AGENT_ONBOARDING_ROLE_OPTIONS` in apps/core. */
export const AGENT_ONBOARDING_ROLES = [
  'Creative',
  'Marketing',
  'Product Design',
  'Founder / Executive',
  'Other',
] as const;

export type AgentOnboardingRole = (typeof AGENT_ONBOARDING_ROLES)[number];

/** Matches time-sink `id` values in `WORKSPACE_AGENT_ONBOARDING_TIME_SINKS` in apps/core. */
export const AGENT_ONBOARDING_TIME_SINK_IDS = [
  'collaboration',
  'multiSelect',
  'generation',
  'distribution',
  'find',
  'analytics',
] as const;

export type AgentOnboardingTimeSinkId = (typeof AGENT_ONBOARDING_TIME_SINK_IDS)[number];

type MetaParam = NonNullable<Meta['params']>[number];

export const AGENT_ONBOARDING_ROLE_META_PARAM = {
  description: 'The role chip the user selected',
  name: 'role',
  required: true,
  type: 'enum',
  values: [...AGENT_ONBOARDING_ROLES],
} satisfies MetaParam;

export const AGENT_ONBOARDING_AUDIENCE_META_PARAM = {
  description:
    'Whether this person just created a workspace in onboarding, or is already in a workspace and seeing the walkthrough for the first time on this browser',
  name: 'audience',
  required: true,
  type: 'enum',
  values: [...AGENT_ONBOARDING_AUDIENCES],
} satisfies MetaParam;
